export const user = ({ user: { user: currentUser } }) => currentUser;
export const projects = ({ project: { projects: allProjects } }) => allProjects;
export const currentProject = ({ project: { currentProject: project } }) =>
  project;
